import React, {useEffect, useState, useMemo, useReducer} from 'react'
import {Typography} from '@material-ui/core';
import Form from 'components/Form';
import GridBlock from 'components/GridBlock';
import Tr from 'translations/Translations';
import {DemandValidationSectionStatus} from "constants/DemandValidationSectionStatus";
import {connect} from 'react-redux'
import ValidationShema from "constants/ValidationShema";
import {withRouter} from "react-router";
import {DemandValidation, DemandValidationKeys} from 'constants/DemandValidation';
import {isDemandModification} from "libs/getDemandStatus";
import ModificationService from "services/ModificationService";
import ENotices2Service from "services/ENotices2Service";
import DemandValidationMessages from "components/DemandValidationMessages";
import ProgressStatus from "constants/ProgressStatus";
import EnoticeStatus from "constants/EnoticeStatus";
import Loading from "components/Loading";
import {makeStyles} from "@material-ui/styles";
import Confirm from "components/popup/confirm/Confirm";
import reduxStore from "redux/store";
import {setSaveStatusError} from "redux/actions";
import WorkableButton from "components/button/WorkableButton";
import iconWorksReducer from "libs/iconWorksReducer";

const useStyle = makeStyles(theme => ({
    root: {},
    rotate: {
        transform: 'rotate(90deg)'
    },
    breadcrumbText: {
        marginRight: theme.spacing(2)
    },
    checkbox: {
        padding: "0 11px"
    },
    selDocuments: {
        marginRight: 200
    },
    dialogContent: {
        minHeight: 500
    },
    loading: {
        position: 'absolute',
        left: '50%',
        transform: 'translateX(-50%)',
        width: 900,
        height: 50,
    },
    titleIcon: {
        position: 'absolute',
        left: theme.spacing(2),
        color: theme.palette.primary.main,
    }
}))

function Deadlines(
    {
        match,
        demandValidation,
        demandHeader,
        enoticeStatus
    }) {
    const classes = useStyle();
    const demandId = match.params.id;
    const section = demandValidation.find(x => x.section === DemandValidation.ENOTICES2);
    const editable = section ? section.editable : false;
    const handleSubmit = () => {
    };
    const [iconWorks, dispatchIconWorks] = useReducer(iconWorksReducer, {
        anyWorks: false,
        notice: false,
        status: false,
        delete: false
    });
    const currentDemandValidation = DemandValidation.ENOTICES2;
    const [openNoticeDeletePopup, setOpenNoticeDeletePopup] = useState(false);

    useEffect(() => {
        if(enoticeStatus.ueNoticeStatus === 'PUBLISHED')
            return;
        ENotices2Service.getNoticeStatusTed(demandId).catch((error) => {
          console.error("Notice status request failed:", error);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [demandId]);

    const STATUS_NEW = enoticeStatus?.internalFormStatus === EnoticeStatus.TED_ERROR;
    const STATUS_SUBMITTED = enoticeStatus?.internalFormStatus === EnoticeStatus.SUBMITTED && enoticeStatus?.ueNoticeStatus !== EnoticeStatus.PUBLISHED;
    const STATUS_UNCREATED = enoticeStatus?.internalFormStatus === EnoticeStatus.UNCREATED;
    const STATUS_PUBLISHED = enoticeStatus?.internalFormStatus === EnoticeStatus.SUBMITTED && enoticeStatus?.ueNoticeStatus === EnoticeStatus.PUBLISHED;
    const STATUS_VALIDATED = enoticeStatus?.internalFormStatus === EnoticeStatus.NEW;

    const reqSectionsError = useMemo(() => {
        const sections = [];
        sections.push(demandValidation.find(x => x.section === DemandValidation.SCHEDULE));
        if (!demandHeader?.passiveOfferForm) {
            sections.push(demandValidation.find(x => x.section === DemandValidation.DEALINGS));
        }
        const errorSections = sections.filter(s => s.status !== DemandValidationSectionStatus.OK).map(s => Tr(DemandValidationKeys[s.section]));

        if (errorSections.length > 0) {
            return `${Tr("national_notice_sections_missing")}: '${errorSections.join("', '")}'`
        }
        return undefined;
    }, [demandValidation, demandHeader]);

    const createNoticeAndGenerateLink = async () => {
        dispatchIconWorks({type: 'notice', works: true});
        const createResp = await ENotices2Service.createNotice(demandId);
        if (createResp.success) {
            const link = await ENotices2Service.generateLink(demandId);
            if (link) {
                window.open(link, "_blank");
            }
        } else {
            reduxStore.dispatch(setSaveStatusError(createResp.errors?.length ? createResp.errors[0] : ''));
        }
        dispatchIconWorks({type: 'notice', works: false});
    }

    const generateLinkAndOpen = async () => {
        dispatchIconWorks({type: 'notice', works: true});
        const link = await ENotices2Service.generateLink(demandId);
        if (!!link) {
            window.open(link, "_blank");
        }
        dispatchIconWorks({type: 'notice', works: false});
    }

    const createChangeNotice = async () => {
        const createResp = await ENotices2Service.createChangeNotice(demandId);
        if (createResp?.uploadStatus === ProgressStatus.ERROR) {
            return;
        }
        const link = await ENotices2Service.generateLink(demandId);
        if (!!link) {
            window.open(link, "_blank");
        }
    }

    const checkNoticeStatus = async () => {
        try {
            dispatchIconWorks({type: 'status', works: true});
            await ENotices2Service.getNoticeStatusTed(demandId, currentDemandValidation);
        } finally {
            dispatchIconWorks({type: 'status', works: false});
        }
    }

    const handlePreviewPdf = async () => {
        const resp = await ENotices2Service.renderNotice(demandId);
        if (!resp) return;

        const blob = new Blob([resp.data], {type: 'application/pdf'});
        const url = window.URL.createObjectURL(blob);
        window.open(url, '_blank');
    };

    const handleConfirmNoticeDelete = () => {
        setOpenNoticeDeletePopup(false);
        dispatchIconWorks({type: 'delete', works: true});
        ENotices2Service.deleteNotice(demandId).then(() => {
            dispatchIconWorks({type: 'delete', works: false});
            checkNoticeStatus();
        });
    };

    return (<div style={{width: "100%"}}>
        {!!reqSectionsError && <Typography color="error">{reqSectionsError}</Typography>}
        <DemandValidationMessages section={section} editable={editable}/>
        <Form
            onSubmit={handleSubmit}
            id='mp_1_national_notice'
            validationSchema={ValidationShema.any()}
            afterSubmitFunc={() => {
                if (isDemandModification()) {
                    ModificationService.isDemandChanged(demandId);
                }
            }}
        >
            {() => (<>
                    {!enoticeStatus?.internalFormStatus && <Loading className={classes.loading}/>}
                    {STATUS_UNCREATED && (
                        <GridBlock justify="center" alignItems="center">
                            <WorkableButton disabled={!editable || !!reqSectionsError || iconWorks.anyWorks} working={iconWorks.notice}
                                    onClick={createNoticeAndGenerateLink}>{Tr("bzp_notice_create")}</WorkableButton>
                            <Typography><br/>{Tr("bzp_notice_create_info")}<br/><br/></Typography>
                            <br/><br/>
                        </GridBlock>)
                    }
                    {STATUS_NEW && section?.status === 'ERROR' && section?.messages?.length > 0 && (
                        <GridBlock direction='column' alignItems='center'>
                            <WorkableButton
                                disabled={!editable || iconWorks.anyWorks} working={iconWorks.notice}
                                onClick={createChangeNotice}>{Tr("enotice_prepare_change")}
                            </WorkableButton>
                            <Typography><br/>{Tr("bzp_notice_create_info")}<br/><br/></Typography><br/>
                        </GridBlock>)
                    }
                    {STATUS_NEW && (section?.status !== 'ERROR' || (section?.status === 'ERROR' && section?.messages?.length === 0)) && (
                        <GridBlock direction='column' alignItems='center'>
                            <Typography>{Tr("enotice_ted_error")}</Typography><br/><br/>
                            <WorkableButton disabled={!!reqSectionsError || iconWorks.anyWorks} working={iconWorks.notice}
                                    onClick={generateLinkAndOpen}>{Tr("bzp_notice_create")}</WorkableButton><br/>
                            <WorkableButton disabled={!!reqSectionsError || iconWorks.anyWorks} working={iconWorks.status}
                                    onClick={checkNoticeStatus}>{Tr("bzp_notice_status")}</WorkableButton><br/><br/>
                            <WorkableButton disabled={!editable || !!reqSectionsError || iconWorks.anyWorks} working={iconWorks.delete}
                                    onClick={() => setOpenNoticeDeletePopup(true)}>
                                {Tr("enotice_delete_notice")}
                            </WorkableButton><br/>
                        </GridBlock>)
                    }
                    {STATUS_VALIDATED && section?.status === 'ERROR' && section?.messages?.length > 0 && (
                        <GridBlock direction='column' alignItems='center'>
                            <WorkableButton
                                disabled={!editable || iconWorks.anyWorks} working={iconWorks.notice}
                                onClick={createChangeNotice}>{Tr("enotice_prepare_change")}
                            </WorkableButton>
                            <Typography><br/>{Tr("bzp_notice_create_info")}<br/><br/></Typography><br/>
                        </GridBlock>)
                    }
                    {STATUS_VALIDATED && (section?.status !== 'ERROR' || (section?.status === 'ERROR' && section?.messages?.length === 0)) && (
                        <GridBlock direction='column' alignItems='center'>
                            <Typography>{Tr("enotice_prepared_section")}<br/><br/></Typography>
                            <WorkableButton disabled={!!reqSectionsError || iconWorks.anyWorks} working={iconWorks.notice}
                                    onClick={generateLinkAndOpen}>{Tr("preview_notice")}</WorkableButton><br/><br/>
                            <WorkableButton disabled={!editable || !!reqSectionsError || iconWorks.anyWorks} working={iconWorks.delete}
                                    onClick={() => setOpenNoticeDeletePopup(true)}>
                                {Tr("enotice_delete_notice")}
                            </WorkableButton><br/>
                        </GridBlock>)
                    }
                    {STATUS_SUBMITTED && section?.status === 'ERROR' && section?.messages?.length > 0 && (
                        <GridBlock direction='column' alignItems='center'>
                            <WorkableButton
                                disabled={!editable || iconWorks.anyWorks} working={iconWorks.notice}
                                onClick={createChangeNotice}>{Tr("enotice_prepare_change")}
                            </WorkableButton>
                            <Typography><br/>{Tr("bzp_notice_create_info")}<br/><br/></Typography><br/>
                        </GridBlock>)
                    }
                    {STATUS_SUBMITTED && (section?.status !== 'ERROR' || (section?.status === 'ERROR' && section?.messages?.length === 0)) && (
                        <GridBlock direction='column' alignItems='center'>
                            <WorkableButton disabled={!!reqSectionsError || iconWorks.anyWorks} working={iconWorks.notice}
                                    onClick={generateLinkAndOpen}>{Tr("preview_notice")}</WorkableButton><br/>
                        </GridBlock>)
                    }
                    {STATUS_PUBLISHED && section?.status === 'ERROR' && section?.messages?.length > 0 && (
                        <GridBlock direction='column' alignItems='center'>
                            <WorkableButton
                                disabled={!editable || iconWorks.anyWorks} working={iconWorks.notice}
                                onClick={createChangeNotice}>{Tr("enotice_prepare_change")}
                            </WorkableButton>
                            <Typography><br/>{Tr("bzp_notice_create_info")}<br/><br/></Typography><br/>
                        </GridBlock>)
                    }
                    {STATUS_PUBLISHED && (section?.status !== 'ERROR' || (section?.status === 'ERROR' && section?.messages?.length === 0)) && (
                        <GridBlock direction='column' alignItems='center'>
                            <WorkableButton
                                disabled={iconWorks.anyWorks} working={iconWorks.notice}
                                onClick={generateLinkAndOpen}>{Tr("preview_notice")}
                            </WorkableButton><br/>
                            <WorkableButton disabled={iconWorks.anyWorks} onClick={handlePreviewPdf} working={iconWorks.status}>
                                {Tr("preview_published_notice")}
                            </WorkableButton><br/>
                        </GridBlock>)}
                    <Confirm
                        open={openNoticeDeletePopup}
                        onConfirm={handleConfirmNoticeDelete}
                        onCancel={() => setOpenNoticeDeletePopup(false)}
                        confirmText="enotice_delete_notice_text"
                        labelCancel="cancel"
                        labelConfirm="confirm2"
                    />
                </>
            )}
        </Form>
    </div>)
}

export default connect((state) => ({
    demandValidation: state.resources.demandValidation,
    demandHeader: state.resources.demandHeader,
    enoticeStatus: state.resources.enoticeStatus
}), {})(withRouter(Deadlines));


